import { createTheme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';

const theme = createTheme();

theme.typography.body1 = {
  // Tell MUI what the font-size on the html element is.
  fontSize: 20,
  // '@media (max-width: 768px)': {
  //   fontSize: 20,
  // },
  [theme.breakpoints.up('md')]: {
    fontSize: 16,
  },
};

const Caption = styled('span')(({ theme }) => ({
  ...theme.typography.caption,
  color: theme.palette.text.secondary,
  [theme.breakpoints.down('md')]: {
    fontSize: '1rem',
  },
}));

export { theme, Caption };
